class VideoThumbnail extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: 'open' });
    const videoSrc = this.getAttribute('data-video-src');

    shadow.innerHTML = `
      <style>
        .video-container {
          position: relative;
          width: 100%;
          height: 100%;
        }
        video {
            display: block;
            width: 100%;
            height: 100%;
        }
        .thumbnail {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            
        }
        .thumbnail.hidden {
            display: none;
        }
        svg {
            fill: white;
            width: 11rem;
            height: 11rem;
        }
        </style>
        <div class="video-container">
          <video >
            <source src="${videoSrc}" type="video/mp4">
          </video>
          <div class="thumbnail">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="32" fill="currentColor" class="w-32 transition-all duration-300"><path d="M407-351l202-129-202-129v258zm73.3 219q-72.21 0-135.43-27.52-63.22-27.53-110.62-74.85-47.4-47.33-74.82-110.26Q132-407.57 132-479.7q0-72.21 27.52-135.93 27.53-63.72 74.85-110.87 47.33-47.15 110.26-74.32Q407.57-828 479.7-828q72.21 0 135.94 27.39 63.72 27.39 110.87 74.35 47.14 46.96 74.31 110.39Q828-552.43 828-480.3q0 72.21-27.27 135.43-27.28 63.22-74.35 110.62-47.08 47.4-110.51 74.82Q552.43-132 480.3-132zm-.37-22q135.57 0 230.82-95.18Q806-344.37 806-479.93q0-135.57-95.18-230.82Q615.63-806 480.07-806q-135.57 0-230.82 95.18Q154-615.63 154-480.07q0 135.57 95.18 230.82Q344.37-154 479.93-154zm.07-326z"></path></svg>
          </div>
        </div>
    `;

    this.video = shadow.querySelector('video');
    const thumbnail = shadow.querySelector('.thumbnail');
    this.video.addEventListener('pause', () => {
      thumbnail.classList.remove('hidden');
    });
    this.video.addEventListener('play', () => {
      thumbnail.classList.add('hidden');
    });
    this.video.addEventListener('ended', () => {
      thumbnail.classList.remove('hidden');
    });
    thumbnail.addEventListener('click', () => {
      this.video.play();
    });
    this.video.addEventListener('click', () => {
      this.video.paused ? this.video.play() : this.video.pause();
    });
  }
  pause() {
    this.video.pause();
  }
  play() {
    this.video.play();
  }
}
customElements.define('video-thumbnail', VideoThumbnail);
